/**
 * Tiempos de turno que se pueden elegir en la sala. Por debajo de veinte
 * segundos no da tiempo a leer la mesa; por encima del minuto, el resto se
 * cansa de esperar.
 */
export const TURN_LIMITS_MS = [20_000, 30_000, 45_000, 60_000];
/** Atajos de apuesta que ofrece la sala; el anfitrion puede escribir otra. */
export const BET_PRESETS = [10, 25, 50];
/**
 * Tope de la apuesta libre. No es una regla del juego: quien manda de verdad es
 * lo que tenga la mesa, porque nadie empieza una partida que no pueda pagar.
 * Esta aqui para que un cero de mas al teclear no llene la barra de digitos.
 */
export const MAX_BET = 9999;
/** Apuesta valida: entera, de 0 (sin bote) al tope. */
export function isBetAmount(amount) {
    return typeof amount === 'number' && Number.isInteger(amount) && amount >= 0 && amount <= MAX_BET;
}
//# sourceMappingURL=protocol.js.map